import React, { useState, useEffect, useRef } from 'react'
import {
  Button,
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Autocomplete,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert
} from '@mui/material'
import GetAppIcon from '@material-ui/icons/GetApp'
import '../CI/COD.css'
import {
  getRequest,
  convertToINR,
  getHumanReadableDate,
  getStandardDate
} from '../../globalhelper/helper'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { CSVLink } from 'react-csv'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'
import moment from 'moment'

const FunctionalJournal = props => {
  // Separate state variables
  const [filterData, setFilterData] = useState({
    column: '',
    value: ''
  })
  const [showTableDetailed, setShowTableDetailed] = useState(false)
  const [showTableSummary, setShowTableSummary] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableDisplay, setTableDisplay] = useState([])

  // Dropdown options
  const [dropdownType] = useState(['Detailed', 'Summary'])
  const [formData, setFormData] = useState({
    period: moment().format('MM-YYYY'),
    fromDate: moment(),
    toDate: moment(),
    Type: '',
    company: ''
  })
  let dispatch = useDispatch()
  const [companyDetails, setCompanyDetails] = useState([])
  const [companyName, setCompanyName] = useState([])

  const downloadLinkRef = useRef(null)

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data
      const orgname = responseData.map(item => item.orgname)
      setCompanyDetails(responseData)
      setCompanyName(orgname)
      if (orgname.length === 1) {
        setFormData(prev => {
          return { ...prev, company: orgname[0] }
        })
      }
    })
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFormData(prev => {
      return { ...prev, fromDate: firstDay, toDate: lastDay }
    })
  }, [])

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  useEffect(() => {
    handleMonthtoDateConversion()
  }, [formData.period])

  const handleMonthtoDateConversion = () => {
    if (!formData.period) return

    const parsedDate = moment(
      formData.period,
      ['YYYY-MM-DD', 'YYYY-MM', 'MM-YYYY'],
      true
    )

    if (!parsedDate.isValid()) {
      console.error('Invalid period value:', formData.period)
      return
    }

    const firstDay = parsedDate.clone().startOf('month').format('YYYY-MM-DD')
    const lastDay = parsedDate.clone().endOf('month').format('YYYY-MM-DD')

    console.log(firstDay, lastDay)

    setFormData(prev => ({
      ...prev,
      fromDate: firstDay,
      toDate: lastDay
    }))
  }

  const handleSubmit = () => {
    dispatch(showLoader())
    const { fromDate, toDate, Type, company } = formData

    const id = companyDetails.filter(item => item.orgname === company)
    const companyid = id.map(item => item.orgid)

    setTableData([])

    getRequest(
      (Type === 'Detailed' &&
        `api/edureka/getFunctionalJournalDetail?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`) ||
        `api/edureka/getFunctionalSummary?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`
    )
      .then(response => {
        const responseData = JSON.parse(response.res.data)

        if (responseData.length) {
          setTableData(responseData)
          setTableDisplay(responseData)
          setShowTableSummary(false)
          setShowTableDetailed(true)
        }
      })
      .catch(err => console.log(err))
      .finally(() => dispatch(hideLoader()))
  }

  const handleReset = () => {
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFormData({
      period: moment().format('MM-YYYY'),
      fromDate: firstDay,
      toDate: lastDay,
      Type: '',
      company: ''
    })
    setTableData([])
    setTableDisplay([])
    setShowTableDetailed(false)
    setShowTableSummary(false)
    setFilterData({
      column: '',
      value: ''
    })
  }

  const handleFilter = (name, value) => {
    setFilterData(prev => ({ ...prev, [name]: value }))
  }

  useEffect(() => {
    applyFilter()
  }, [filterData.column, filterData.value])

  const applyFilter = () => {
    console.log(filterData)

    if (filterData.column && filterData.value) {
      const filterItem = tableData.filter(
        item => item[filterData.column] === filterData.value
      )
      console.log(filterItem)
      setTableDisplay(filterItem)
    } else {
      setTableDisplay(tableData)
    }
  }

  const columnNames = tableData.length ? Object.keys(tableData[0]) : []
  const columnValues = filterData.column
    ? [...new Set(tableData.map(item => item[filterData.column]))]
    : []

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                options={companyName || []}
                value={formData.company}
                onChange={(e, newValue) => handleChange('company', newValue)}
                fullWidth
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='Period'
                  value={moment(formData.period, 'MM-YYYY')}
                  views={['month', 'year']}
                  onChange={newValue => {
                    handleChange('period', newValue.format('MM-YYYY'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                options={dropdownType || []}
                value={formData.Type}
                onChange={(e, newValue) => handleChange('Type', newValue)}
                fullWidth
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Type'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color='primary'
                size='small'
                onClick={handleSubmit}
                disabled={
                  !formData.company ||
                  !formData.Type ||
                  !formData.toDate ||
                  !formData.fromDate
                }
              >
                Submit
              </Button>
              &nbsp;
              <Button
                variant='contained'
                color='error'
                size='small'
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          {tableData.length > 0 && (
            <>
              <Typography variant='h6' mt={2} mb={1}>
                Filter
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={columnNames || []}
                    value={filterData.column}
                    onChange={(e, newValue) => handleFilter('column', newValue)}
                    fullWidth
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='Select Column'
                        variant='outlined'
                        size='small'
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={columnValues || []}
                    value={filterData.value}
                    onChange={(e, newValue) => handleFilter('value', newValue)}
                    fullWidth
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='Select Value'
                        variant='outlined'
                        size='small'
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  {tableData.length > 0 && (
                    <Grid item>
                      <CSVLink
                        data={tableDisplay}
                        filename={`Functional Journal ${formData.fromDate} to ${formData.toDate}.csv`}
                        ref={downloadLinkRef}
                        style={{ textDecoration: 'none' }}
                      >
                        <Button variant='contained' color='success'>
                          <GetAppIcon
                            fontSize='small'
                            style={{ color: 'white' }}
                          />
                        </Button>
                      </CSVLink>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {tableData.length > 0 && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {Object.keys(tableData[0]).map((col, index) => (
                  <TableCell key={index} sx={{ whiteSpace: 'nowrap' }}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(tableDisplay.length > 0 &&
                tableDisplay.map((item, index) => (
                  <TableRow key={index}>
                    {Object.keys(tableData[0]).map((col, index) => (
                      <TableCell key={index} sx={{ whiteSpace: 'nowrap' }}>
                        {item[col]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))) || (
                <TableRow>
                  <TableCell
                    colSpan={Object.keys(tableData[0])?.length}
                    sx={{ p: 5 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  )
}

export default FunctionalJournal
